import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import languages from '../../lang';
import langManager from '../../lang/lang-manager';
import ReactSelect from '../Campaign/Create/FormComponents/ReactSelect';
import { colors } from '../../styles/_vars';

const LanguageSelectStyled = styled.div`
  padding: 22px 35px;
  display: flex;
  align-items: center;
  
  i { font-size: 22px; }
  
  .language-select-wrapper {
    max-width: 175px;
    margin-left: 14px;
    flex-grow: 1;
    
    .language-select__control {
      border-radius: 5px;
      box-shadow: none;
      border-color: ${colors.grayDark};
      background: ${colors.grayDarker3};
      
      .language-select__single-value { color: ${colors.gray}; }
    }

    .language-select__menu:after { display: none; }
  }
  
  @media screen and (max-width: 550px) { padding: 10px 18px; }
`;

const LanguageSelect = ({ locale }) => {
  const formattedLocaleAsOption = useMemo(() => ({
    value: locale,
    label: languages.LANGUAGES_CODES_AND_LABELS[locale].label,
  }), [locale]);

  const changeLangCallback = useCallback(({ value }) => {
    langManager.changeLocale(value);
  }, []);

  return (
    <LanguageSelectStyled>
      <i className="material-icons">language</i>

      <ReactSelect
        options={languages.LANGUAGES_SELECT_OPTIONS}
        className="language-select-wrapper"
        classNamePrefix="language-select"
        defaultValue={formattedLocaleAsOption}
        onChange={changeLangCallback}
        isSearchable={false}
        menuPlacement="top"
      />
    </LanguageSelectStyled>
  );
};

LanguageSelect.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = ({ user }) => ({
  locale: user.get('locale'),
});

export default connect(mapStateToProps)(LanguageSelect);
